export enum GameScoringSystemCategory {
  SELECTION = 'selection',
  TIME_RANGE = 'time_range',
  NONE = 'none'
}
